export type Crumb = {
  label: string
  onClick?: (() => void) | undefined
}

type Props = {
  crumbs: Crumb[]
}

/**
 * Shared breadcrumb nav component.
 *
 * - Earlier crumbs (with `onClick`) render as `<button>` so they remain accessible by role.
 * - The final crumb (no `onClick`) renders as a non-interactive `<span>` (current page).
 * - The `›` separator renders between crumbs only (not before the first or after the last).
 */
export function Breadcrumb({ crumbs }: Props) {
  return (
    <nav className='mb-sp-1 flex items-center gap-sp-0.75'>
      {crumbs.map((crumb, index) => {
        const isLast = index === crumbs.length - 1
        return (
          <span key={crumb.label} className='flex items-center gap-sp-0.75'>
            {index > 0 && <span className='text-size-3 text-text-light'>›</span>}
            {isLast || !crumb.onClick ?
              <span className='text-size-3 font-normal leading-5 text-text-dark'>{crumb.label}</span>
            : <button
                type='button'
                className='cursor-pointer border-none bg-none p-0 text-size-3 font-normal leading-5 text-text-light hover:text-text-dark'
                onClick={crumb.onClick}>
                {crumb.label}
              </button>
            }
          </span>
        )
      })}
    </nav>
  )
}
